import { getDocPage } from "@/content/docs/index";
import { BRAND_NAME } from "@/lib/brand";
import { docsSlugFromPath, isDocsPath } from "@/lib/docsPath";

const HOME_META = { title: "meta.title", description: "meta.description" };

const META: Record<string, { title: string; description: string }> = {
  "/": HOME_META,
  "/product": { title: "meta.productTitle", description: "meta.productDescription" },
  "/security": { title: "meta.securityTitle", description: "meta.securityDescription" },
  "/about": { title: "meta.aboutTitle", description: "meta.aboutDescription" },
  "/pricing": { title: "meta.pricingTitle", description: "meta.pricingDescription" },
  "/download": { title: "meta.downloadTitle", description: "meta.downloadDescription" },
  "/contact": { title: "meta.contactTitle", description: "meta.contactDescription" },
  "/referral": { title: "meta.referralTitle", description: "meta.referralDescription" },
  "/legal/terms": { title: "meta.termsTitle", description: "meta.termsDescription" },
  "/legal/privacy": { title: "meta.privacyTitle", description: "meta.privacyDescription" },
};

export type PageMeta = { title: string; description: string };

/**
 * Per-route `<title>` and meta description.
 *
 * Marketing routes resolve through i18n keys. Documentation titles come from
 * the page content instead — a docs page's H1 and its search-result headline
 * must never be able to drift apart, so both read the same field.
 */
export function resolvePageMeta(pathname: string, t: (key: string) => string): PageMeta {
  if (isDocsPath(pathname)) {
    return docsMeta(pathname);
  }
  const entry = META[pathname] ?? HOME_META;
  return { title: t(entry.title), description: t(entry.description) };
}

function docsMeta(pathname: string): PageMeta {
  const slug = docsSlugFromPath(pathname);
  const page = slug === "index" ? undefined : getDocPage(slug);

  if (!page) {
    return {
      title: `${BRAND_NAME} Documentation — AI trading agent guides and reference`,
      description: `How ${BRAND_NAME} works: research a company with sourced evidence, backtest a strategy, connect a broker, approve every trade, and drive it all from Claude or ChatGPT over MCP.`,
    };
  }

  return {
    title: `${page.title} — ${BRAND_NAME} Docs`,
    description: page.description,
  };
}
